import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import { Grid } from "@mui/material";
import AddIcon from "@material-ui/icons/Add";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  getTestsRequest,
  setTestsFilters,
  getTestsResponse,
  setTestsPage,
  setTestsBookIdFilters
} from "../../store/Tests/actions";
import EmptyState from "../../components/EmptyState";
import Pagination from "../../components/Pagination";
import messages from "../../assets/locale/messages";
import { ROUTE_PATHS } from "../../utils/PathsNames";
import Button from "../../components/Button";
import Search from "../../components/Search";
import PreTestPostTestList from "./PreTestPostTestList";
import PreTestPostTestDelete from "./PreTestPostTestDelete";
import { deleteAction } from "../../store/ActionsBtn/actions";
import Title_Section from "../../components/Title_Section/Title_Section";
import styles from "./PreTestPostTest.module.scss";
import CustomSelect from "../../components/Select";
import { getBooksRequest } from "../../store/Books/actions";
const PreTestPostTest = () => {
  const perPage = 6;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const isLoading = useSelector((state) => state.loader);
  const meta = useSelector((state) => state.tests.meta);
  const lang = useSelector((state) => state.locale.lang);
  const deleteId = useSelector((state) => state.actionsBtn.delete);
  const { searchKeyword, testsBookIdFilter, TestsPage } = useSelector(
    (state) => state.tests
  );
  const testList = useSelector((state) => state.tests.list);
  const booksList = useSelector((state) => state.books.list);
  const [booksOptions, setBooksOptions] = useState([]);
  useEffect(() => {
    dispatch(getBooksRequest({ lookup: true }));
  }, []);
  useEffect(() => {
    if (booksList.length) {
      setBooksOptions([
        { id: 0, value: 0, label: "No Filter" },
        ...booksList.map(({ id, title }) => ({
          id,
          value: id,
          label: title
        }))
      ]);
    }
  }, [booksList]);
  const {
    inputs: { filterByBook },
    preTestPostTest: { title, addTest }
  } = messages[lang];
  const handleCancelDelete = () => {
    dispatch(deleteAction(0));
  };

  useEffect(() => {
    function filterTestsList() {
      const params = {
        page: TestsPage,
        items: perPage,
        title: searchKeyword,
        book_id: testsBookIdFilter
      };
      if (!testsBookIdFilter) {
        delete params.book_id;
      }
      dispatch(getTestsRequest(params));
    }
    filterTestsList();
  }, [searchKeyword, TestsPage, testsBookIdFilter]);
  useEffect(() => {
    return () => {
      dispatch(getTestsResponse({ list: [], meta: {} }));
    };
  }, []);
  useEffect(() => {
    return () => {
      dispatch(
        setTestsFilters({
          searchKeyword: null
        })
      );
    };
  }, []);
  const handlePagination = (event, page) => {
    setPage(page);
    dispatch(
      getTestsRequest({
        page: page,
        items: perPage,
        title: searchKeyword,
        book_id: testsBookIdFilter ? testsBookIdFilter : null,
        paginate: true
      })
    );
  };
  const handleSearch = (e) => {
    dispatch(
      setTestsFilters({
        searchKeyword: e.target.value
      })
    );
  };
  const handleSelectedBookFilter = (id) => {
    if (id) {
      // dispatch(
      //   getTestsRequest({
      //     page: TestsPage,
      //     title: searchKeyword,
      //     items: 10,
      //     book_id: id,
      //     sort_by_book_page: true
      //   })
      // );
      dispatch(setTestsBookIdFilters({ id }));
    } else {
      // dispatch(
      //   getTestsRequest({
      //     page: TestsPage,
      //     title: searchKeyword,
      //     items: 10
      //   })
      // );
      dispatch(setTestsBookIdFilters({ id: 0 }));
    }
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={title} />
      </div>
      <Grid container className="d-flex justify-content-between g-2">
        <Grid item md={8}>
          <Formik initialValues={{ search: "", book_id: null }}>
            {() => (
              <Form style={{ display: "flex", gap: "10px" }}>
                <Search
                  name="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
                <CustomSelect
                  options={booksOptions}
                  placeholder={filterByBook}
                  name="book_id"
                  style={{ width: "50%" }}
                  isRequired={false}
                  isMenuRelative={false}
                  handleSelectChange={(id) => {
                    handleSelectedBookFilter(id);
                  }}
                />
              </Form>
            )}
          </Formik>
        </Grid>
        <Grid
          item
          md={4}
          className="d-flex align-items-start justify-content-end"
        >
          <Button
            text={addTest}
            icon={<AddIcon className="me-2" />}
            isLink={true}
            onClick={() => sessionStorage.removeItem("bookSelected")}
            slug={ROUTE_PATHS["addPreTestPostTest"]}
          />
        </Grid>
      </Grid>
      <PreTestPostTestList
        list={testList}
        lang={lang}
        inBookView={false}
      />
      <PreTestPostTestDelete
        handleCancelDelete={handleCancelDelete}
        isOpen={!!deleteId}
        lang={lang}
      />
      {!isLoading && !testList.length && <EmptyState />}

      <div className={styles.footerDiv}>
        {meta.pages > 1 && (
          <>
            <div className={styles.PageNumberDiv}>
              <label htmlFor="pageInput">Page Number</label>
              <input
                id="pageInput"
                value={page}
                className={styles.InputPage}
                onChange={(e) => setPage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // stop form submission / reload
                    dispatch(setTestsPage({ page: Number(page) }));
                  }
                }}
              />
              <button
                className={styles.ArrowButton}
                onClick={() =>
                  dispatch(setTestsPage({ page: Number(page) }))
                }
                title="Go To Page"
              >
                <ArrowForwardIcon className="mx-2" />
              </button>
            </div>
            <Pagination
              count={meta.pages}
              page={meta.currentPage || page}
              handleChange={handlePagination}
            />
          </>
        )}
      </div>
    </>
  );
};

export default PreTestPostTest;
